
import Xrp from "../../../assets/duotone/Xrp.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function XrpIcon({ className, dataTestid = "XrpIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Xrp data-testid={dataTestid} className={classes} {...rest} />
  );
}
